import { createUrl } from '@/utils';

const notifications = createUrl('notifications/lp');

const email = notifications('email');
const sms = notifications('sms');

export const notificationsEndpoints = { email, sms };
